import React from "react";
import * as Icons from "lucide-react";
import { stats } from "../mock";
import { CountUp } from "../components/common";

const Stats = () => {
  return (
    <section className="py-16 bg-[#CD0008]">
      <div className="max-w-[1320px] mx-auto px-5 grid grid-cols-2 lg:grid-cols-4 gap-8">
        {stats.map((s, i) => {
          const Icon = Icons[s.icon] || Icons.Trophy;
          return (
            <div
              key={i}
              className={`text-center text-white px-4 ${
                i < stats.length - 1 ? "lg:border-r lg:border-white/25" : ""
              }`}
            >
              <Icon size={40} className="mx-auto mb-3" />
              <div className="display-heading text-5xl">
                <CountUp end={s.value} suffix={s.suffix} />
              </div>
              <p className="mt-2 uppercase tracking-wide text-sm text-white/90">{s.label}</p>
            </div>
          );
        })}
      </div>
    </section>
  );
};

export default Stats;
